import { render, staticRenderFns } from "./AbsenceCalendar.vue?vue&type=template&id=b8b439f2&"
import script from "./AbsenceCalendar.vue?vue&type=script&lang=js&"
export * from "./AbsenceCalendar.vue?vue&type=script&lang=js&"
import style0 from "./AbsenceCalendar.vue?vue&type=style&index=0&id=b8b439f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports